export const footerDB = [
    [
      {
        _id: 10,
        title: 'Find a Doctor',
        url: 'dfgh'
      },
      {
        _id: 11,
        title: 'myMedicare',
        url: 'dfgh'
      },
      {
        _id: 12,
        title: 'Find a Hospital or Clinic Near You',
        url: 'dfgh'
      },
      {
        _id: 14,
        title: 'Immediate Care Locations',
        url: 'dfgh'
      },
      {
        _id: 15,
        title: 'Emergency Department Locations',
        url: 'dfgh'
      },
      {
        _id: 16,
        title: 'Check your Insurance',
        url: 'dfgh'
      },
      {
        _id: 17,
        title: 'International Patients',
        url: 'dfgh'
      },
      {
        _id: 18,
        title: 'International Patients',
        url: 'dfgh'
      },
    ],
    [
      {
        _id: 140,
        title: 'Work at UCLA Health',
        url: 'dfgh'
      },
      {
        _id: 131,
        title: 'Donate to Medicare',
        url: 'dfgh'
      },
      {
        _id: 152,
        title: 'Voulunteer for Medicare',
        url: 'dfgh'
      },
      {
        _id: 134,
        title: 'Share Your Experience',
        url: 'dfgh'
      },
      {
        _id: 315,
        title: 'Subscribe to Our Newslater',
        url: 'dfgh'
      }
    ]
]

